import React from 'react';
import './AboutHero.css';
import Container from './Container'
const AboutHero = () => {
  return (
    <section className="about-hero-section">
      <Container>
      <div className="about-hero-container">
        <div className="about-hero-image">
          <img 
            src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=700&fit=crop" 
            alt="Professional woman" 
          />
        </div>
        
        <div className="about-hero-content">
          <h1>About ELDR-US</h1>
          
          <p className="about-intro">
            ELDR-US is designed from the ground up to enable key stakeholders (Individuals / Relatives 
            Personal Representatives / healthcare providers/ facilities) to securely store and access critical, 
            life-saving information. ELDR stores documents (Advance directives, medical forms, 
            passport, the means of Relocation/ Personal and Medical information and project documents 
            document of any individual). ELDR uses DOS-level encryption at rest and Security network to 
            maintain the privacy of ELDR users and their personal information.
          </p>

          <div className="about-features">
            <p><strong>ELDR-US is now Have for the Web Portal Application www.ELDRdigrey.com</strong></p>
            <p>ELDR is a protected portal.</p>
            
            <ul className="features-list">
              <li>U.S. Government Registered as a Security Operations Certified</li>
              <li>Medical / Portal Application Development</li>
              <li>Cloud Based</li>
              <li>Safe</li>
            </ul>

            <div className="credentials">
              <p><strong>Registered & National HIPAA Guid</strong></p>
              <ul className="credentials-list">
                <li>Facilities (RHIO/HIE/CCO)</li>
                <li>Government</li>
                <li>Business (IR and 3rd Party Administrator Benefits)</li>
              </ul>
              <p><strong>If you want us: then Best Business Support vendore</strong></p>
              <ul className="credentials-list">
                <li>Business New Development</li>
                <li>Increased Product Marketplace</li>
              </ul>
            </div>
          </div>

          <button className="about-read-more-btn">Read More</button>
        </div>
      </div>
      </Container>
    </section>
  );
};

export default AboutHero;
